import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  tagList: {
    ...dFlex('start'),
    flexWrap: 'wrap',
    gap: 16,
    paddingLeft: 4,
    paddingBottom: 4,
  },
}));

export default useStyles;
